<template>
  <div :style="{ height: '100%'}">
    <ceshi></ceshi>
  </div>
</template>
<script >
import ceshi from "../home/components/Map/index.vue"
export default {
  name: "",
  components: { ceshi },
  props: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  methods: {

  },
  created() { },
  mounted() {

  }
}
</script>
<style lang="scss" scoped>

</style>